if (!customElements.get('infinite-scroll-pagination')) {
  class InfiniteScrollPagination extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.loading = false;
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '0px 0px 800px 0px',
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    onIntersect(entries) {
      if (this.loading || !entries.some((entry) => entry.isIntersecting)) return;

      const nextLink = this.querySelector('[data-pagination-next]');
      if (!nextLink) {
        this.observer.disconnect();
        return;
      }

      this.loadNextPage(nextLink.href);
    }

    showSpinner() {
      this.spinner = document.createElement('div');
      this.spinner.className = 'infinite-scroll-pagination__spinner';
      this.spinner.setAttribute('aria-hidden', 'true');
      this.after(this.spinner);
    }

    hideSpinner() {
      this.spinner?.remove();
      this.spinner = null;
    }

    async loadNextPage(url) {
      this.loading = true;
      this.showSpinner();

      const currentGrid = document.getElementById('product-grid');
      const separator = url.includes('?') ? '&' : '?';

      try {
        const response = await fetch(`${url}${separator}section_id=${this.sectionId}`);
        if (!response.ok) throw new Error(response.statusText);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = doc.getElementById('product-grid');

        if (newGrid && currentGrid) {
          Array.from(newGrid.children).forEach((item) => currentGrid.appendChild(item));
        }

        const newWrapper = doc.querySelector('infinite-scroll-pagination');
        this.innerHTML = newWrapper ? newWrapper.innerHTML : '';

        if (typeof initializeScrollAnimationTrigger === 'function' && currentGrid) {
          initializeScrollAnimationTrigger(currentGrid.parentElement);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.hideSpinner();
        this.loading = false;
        if (!this.querySelector('[data-pagination-next]')) this.observer.disconnect();
      }
    }
  }

  customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);
}
